export const DEFAULT_MEDIA_AMOUNT_FOR_ABOUTUS_SUBPAGE = 100;
